import { SupportedLocale } from "@/i18n";
import { Artwork } from "@/lib/types";
import { MergedDisplayData } from "./types";

interface ArtworkPhotoMasterInfoProps {
  data: Artwork;
  displayData: MergedDisplayData;
  locale: SupportedLocale;
  t: (key: string) => string;
}

export function ArtworkPhotoMasterInfo({
  data,
  displayData,
  locale,
  t,
}: ArtworkPhotoMasterInfoProps) {
  const artworkData = data as any;
  // For PHOTO_MASTER: show masterDescription if published, otherwise show public notes
  if (
    artworkData.oeuvresTirageMasterDescriptionPublished &&
    artworkData.oeuvresTirageMasterDescription &&
    (artworkData.oeuvresTirageMasterDescription as Record<string, string>)?.[
      locale
    ]
  ) {
    return (
      <div className="my-1 mt-4 flex flex-col gap-4 font-medium text-sm subpixel-antialiased">
        {t("singleArtworkSubtitleTirageMasterDescription")}
        <div
          dangerouslySetInnerHTML={{
            __html:
              (
                artworkData.oeuvresTirageMasterDescription as Record<
                  string,
                  string
                >
              )[locale] || "",
          }}
          className="font-normal text-sm subpixel-antialiased"
        />
      </div>
    );
  }

  if (
    !artworkData.oeuvresTirageMasterDescriptionPublished &&
    displayData?.oeuvresValidationRemarquesPubliquesMultilingual?.[locale]
  ) {
    return (
      <div className="my-1 mt-4 flex flex-col gap-4 font-medium text-sm subpixel-antialiased">
        {t("singleArtworkSubtitlePublicNote")}
        <div
          dangerouslySetInnerHTML={{
            __html:
              displayData?.oeuvresValidationRemarquesPubliquesMultilingual[
                locale
              ],
          }}
          className="font-normal text-sm subpixel-antialiased"
        />
      </div>
    );
  }

  return null;
}
